import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  regions: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_REGIONS_BUSY: (state, payload) => {
    state.regions.isBusy = payload;
  },
  LOAD_REGIONS_SUCCESS: (state, payload) => {
    state.regions.data = payload.data;
    state.regions.error = null;
  },
  LOAD_REGIONS_FAIL: (state, payload) => {
    state.regions.data = null;
    state.regions.error = payload;
  }
};

const actions = {
  getRegions: ({ commit, rootState }, { projectId, pagination }) => {
    commit('LOAD_REGIONS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/regions${query}`, config)
      .then(response => {
        commit('LOAD_REGIONS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_REGIONS_FAIL', error)
      })
      .finally(() => commit('LOAD_REGIONS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};